export const NeuralLoadingBackground = () => {
    return (
        <>
            <div
                className={'absolute inset-0 bg-slate-950'}
                aria-hidden={true}
            />

            <div
                className={'text-primary absolute inset-0 opacity-20'}
                aria-hidden={true}
            >
                <div
                    className={'absolute inset-0'}
                    style={{
                        backgroundImage:
                            'linear-gradient(color-mix(in srgb, var(--color-primary) 10%, transparent) 1px, transparent 1px), linear-gradient(90deg, color-mix(in srgb, var(--color-primary) 10%, transparent) 1px, transparent 1px)',
                        backgroundSize: '50px 50px',
                    }}
                />
            </div>

            <svg
                className={'absolute inset-0 h-full w-full'}
                xmlns={'http://www.w3.org/2000/svg'}
                preserveAspectRatio={'xMidYMid meet'}
                viewBox={'0 0 600 400'}
                aria-hidden={true}
            >
                <defs>
                    <linearGradient
                        id={'connection-gradient'}
                        x1={'0%'}
                        y1={'0%'}
                        x2={'100%'}
                        y2={'0%'}
                    >
                        <stop
                            offset={'0%'}
                            stopColor={'currentColor'}
                            stopOpacity={'0.8'}
                            className={'text-primary'}
                        />
                        <stop
                            offset={'50%'}
                            stopColor={'currentColor'}
                            stopOpacity={'0.6'}
                            className={'text-purple'}
                        />
                        <stop
                            offset={'100%'}
                            stopColor={'currentColor'}
                            stopOpacity={'0.8'}
                            className={'text-pink-500'}
                        />
                    </linearGradient>
                    <filter id={'glow'}>
                        <feGaussianBlur
                            stdDeviation={'3'}
                            result={'coloredBlur'}
                        />
                        <feMerge>
                            <feMergeNode in={'coloredBlur'} />
                            <feMergeNode in={'SourceGraphic'} />
                        </feMerge>
                    </filter>
                </defs>

                {[100, 180, 260, 340].map((y, i) => (
                    <circle
                        key={`input-${i}`}
                        cx={'80'}
                        cy={y}
                        r={'12'}
                        fill={'currentColor'}
                        className={'neuron text-primary'}
                        filter={'url(#glow)'}
                        style={{ animationDelay: `${i * 0.3}s` }}
                    />
                ))}

                {[80, 160, 240, 320].map((y, i) => (
                    <circle
                        key={`hidden1-${i}`}
                        cx={'220'}
                        cy={y}
                        r={'14'}
                        fill={'currentColor'}
                        className={'neuron text-purple'}
                        filter={'url(#glow)'}
                        style={{ animationDelay: `${0.2 + i * 0.3}s` }}
                    />
                ))}

                {[100, 180, 260, 340].map((y, i) => (
                    <circle
                        key={`hidden2-${i}`}
                        cx={'400'}
                        cy={y}
                        r={'14'}
                        fill={'currentColor'}
                        className={'neuron text-pink-500'}
                        filter={'url(#glow)'}
                        style={{ animationDelay: `${0.4 + i * 0.3}s` }}
                    />
                ))}

                {[140, 220, 300].map((y, i) => (
                    <circle
                        key={`output-${i}`}
                        cx={'540'}
                        cy={y}
                        r={'16'}
                        fill={'currentColor'}
                        className={'neuron text-primary'}
                        filter={'url(#glow)'}
                        style={{ animationDelay: `${0.6 + i * 0.3}s` }}
                    />
                ))}

                {[100, 180, 260, 340].flatMap((y1, i) =>
                    [80, 160, 240, 320].map((y2, j) => (
                        <line
                            key={`l1-${i}-${j}`}
                            x1={'80'}
                            y1={y1}
                            x2={'220'}
                            y2={y2}
                            stroke={'url(#connection-gradient)'}
                            strokeWidth={'1.5'}
                            opacity={'0.4'}
                            className={'connection-line'}
                            style={{ animationDelay: `${(i + j) * 0.1}s` }}
                        />
                    )),
                )}

                {[80, 160, 240, 320].flatMap((y1, i) =>
                    [100, 180, 260, 340].map((y2, j) => (
                        <line
                            key={`l2-${i}-${j}`}
                            x1={'220'}
                            y1={y1}
                            x2={'400'}
                            y2={y2}
                            stroke={'url(#connection-gradient)'}
                            strokeWidth={'1.5'}
                            opacity={'0.4'}
                            className={'connection-line'}
                            style={{ animationDelay: `${0.5 + (i + j) * 0.1}s` }}
                        />
                    )),
                )}

                {[100, 180, 260, 340].flatMap((y1, i) =>
                    [140, 220, 300].map((y2, j) => (
                        <line
                            key={`l3-${i}-${j}`}
                            x1={'400'}
                            y1={y1}
                            x2={'540'}
                            y2={y2}
                            stroke={'url(#connection-gradient)'}
                            strokeWidth={'1.5'}
                            opacity={'0.4'}
                            className={'connection-line'}
                            style={{ animationDelay: `${1 + (i + j) * 0.1}s` }}
                        />
                    )),
                )}

                {[...Array(8)].map((_, i) => (
                    <circle
                        key={`particle-${i}`}
                        r={'3'}
                        fill={'currentColor'}
                        className={'text-primary'}
                        opacity={'0'}
                    >
                        <animateMotion
                            dur={`${1.5 + Math.random() * 0.5}s`}
                            repeatCount={'indefinite'}
                            begin={`${i * 0.2}s`}
                            path={`M 80,${100 + i * 40} L 220,${80 + i * 40} L 400,${100 + i * 40} L 540,${140 + (i % 3) * 80}`}
                        />
                        <animate
                            attributeName={'opacity'}
                            values={'0;1;1;0'}
                            dur={`${1.5 + Math.random() * 0.5}s`}
                            repeatCount={'indefinite'}
                            begin={`${i * 0.2}s`}
                        />
                    </circle>
                ))}
            </svg>
        </>
    );
};
